<template>
  <div class="shareDetails_index_item">
    <li class="box">
      <div>排名</div>
      <div>奖品</div>
      <div>最低成交门槛</div>
    </li>
    <ul>
      <li class="box_item">
        <div>第一名</div>
        <div class="van-ellipsis ">
          <img src="../../../assets/outher/down.png" alt="" class="img" />
          预置商预置商品预置商品预置商品品
        </div>
        <div>第二名</div>
      </li>
     <li class="box_item">
        <div>第一名</div>
        <div class="van-ellipsis ">
          <img src="../../../assets/outher/down.png" alt="" class="img" />
          预置商预置商品预置商品预置商品品
        </div>
        <div>第二名</div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
  .shareDetails_index_item{
    background: #fff;
    height: 1109px;
    border-radius: 20px;
    padding: 40px 30px;
    font-size: 22px;
    color: #666;
    .box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 65px;
      background: #f7f7f7;
      div{
        text-align: center;
        flex: 1;
      }
    }
    .box_item{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100px;
      border-bottom: 1px solid #eee;
      div{
        text-align: center;
        flex: 1;
        img{
          width: 80px;
          height: 80px;
          object-fit: cover;
          vertical-align: middle;
        }
      }
    }
    .red{
      color: #ED3939;
    }
  }
</style>